var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 49,
    viewBox: "0 0 41 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3356_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3332 2H10.738C7.50319 2 4.88086 4.62233 4.88086 7.85714V37.1429C4.88086 40.3777 7.50319 43 10.738 43H30.2618C33.4966 43 36.119 40.3777 36.119 37.1429V11.7619H32.2142C29.5185 11.7619 27.3332 9.57663 27.3332 6.88095V2Z",
    fill: "#F7F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 2L36.119 11.7619H32.2142C29.5185 11.7619 27.3333 9.57663 27.3333 6.88095V2Z",
    fill: "#534AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2856 26H18.6189V18H17.2856V26ZM19.9522 28.6667H21.2856V15.3334H19.9522V28.6667ZM14.6189 23.3334H15.9522V20.6667H14.6189V23.3334ZM22.6189 26H23.9522V18H22.6189V26ZM25.2856 20.6667V23.3334H26.6189V20.6667H25.2856Z",
    fill: "#534AD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3356_236",
    x: 0.880859,
    y: 0,
    width: 39.238,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3356_236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3356_236",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTypeIcon);
export default __webpack_public_path__ + "static/media/Document Type Icon.d9895fdc8062a4363f9cb82e8cdea313.svg";
export { ForwardRef as ReactComponent };